import { Injectable } from '@angular/core';
import { AuthGuard } from '@spartacus/core';

/**
 * Checks if there is currently logged in user.
 * Use to protect pages dedicated only for logged in users.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomAuthGuard extends AuthGuard {}
